import React, { useEffect, useState } from 'react';
import {
  CheckOutlined,
  WarningOutlined,
  ShareAltOutlined,
  FormOutlined,
  ArrowLeftOutlined,
  UserSwitchOutlined
} from '@ant-design/icons';
import { Progress, Button, Avatar, Row, Typography, Select } from 'antd';
import CustomButton from '@/common/CustomButton';
import styles from './index.module.less';
import ColorHash from 'color-hash';
import { useNavigate } from 'react-router-dom';
import CountCard from 'pages/AllEmployeeTasks/components/CountCard';
import { EXECUTIVE } from 'utilities/roleRights';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchStaffAssignments,
  selectStaffingSlice,
  fetchStaffProjects
} from '../redux/slice';
import { getAllProjects } from 'pages/Tasks/redux/slice';
import { getLoggedInUser } from 'utilities/helpers';

const colorHash = new ColorHash({ lightness: 0.7 });
const colorHasher = new ColorHash({ lightness: 0.7 });
const { Title, Text } = Typography;

const StaffPlanning = () => {
  const [projectCount, setProjectCount] = useState(0);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [viewMode, setViewMode] = useState('member');
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { loading, staffAssignments, staffingStats, staffProjects } =
    useSelector(selectStaffingSlice);

  console.log('loading', loading);
  console.log('staffAssignments', staffAssignments);
  console.log('staffingStats', staffingStats);
  console.log('staffProjects', staffProjects);

  useEffect(() => {
    dispatch(fetchStaffAssignments({}));
    dispatch(fetchStaffProjects());
    dispatch(getAllProjects()).then((res) => {
      if (res?.payload?.success) {
        setProjectCount(res.payload.data?.length || 0);
      }
    });
  }, [dispatch]);

  console.log('projectCount', projectCount);
  const getProgressColor = (value) => {
    if (value >= 100) return 'red';
    if (value >= 80) return 'blue';
    if (value >= 60) return '#27C36A';
    return '#27C36A';
  };
  const colorScheme = {
    red: ['#EF4444', '#FCA5A5'],
    green: ['#27C36A', '#A7F3D0'],
    blue: ['#3B82F6', '#BFDBFE']
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase();
  };

  const handleClick = () => {
    navigate('/manage-staffing');
  };

  const data =
    staffAssignments?.map((employee) => {
      const activeProjects = employee.assignments.filter(
        (a) => a.utilization_type === 'active'
      );
      const upcomingProjects = employee.assignments.filter(
        (a) => a.utilization_type === 'upcoming'
      );

      const activeUtil = activeProjects.reduce(
        (sum, a) => sum + a.utilization_percentage,
        0
      );
      const upcomingUtil = upcomingProjects.reduce(
        (sum, a) => sum + a.utilization_percentage,
        0
      );

      const totalUtil = activeUtil + upcomingUtil;

      // Cap width to max 100%
      const cap = totalUtil > 100 ? 100 / totalUtil : 1;
      const activeWidth = activeUtil * cap;
      const upcomingWidth = upcomingUtil * cap;

      // Dynamic color selection based on total utilization
      let colorKey;
      if (totalUtil > 100) {
        colorKey = 'red';
      } else if (totalUtil > 80) {
        colorKey = 'blue';
      } else {
        colorKey = 'green'; // for utilization <= 60 or any other case
      }

      return {
        name: `${employee.assignments[0]?.user?.first_name || ''} ${
          employee.assignments[0]?.user?.last_name || ''
        }`,
        utilization: employee.total_utilization || totalUtil,
        activeUtil,
        upcomingUtil,
        activeCount: activeProjects.length,
        upcomingCount: upcomingProjects.length,
        activeWidth,
        upcomingWidth,
        colorKey, // Changed from 'color' to 'colorKey'
        projects: employee.assignments.map((a) => ({
          name: a.project.project,
          company: a.project.client?.client_name || 'Client',
          utilization_type: a.utilization_type,
          utilization_percentage: a.utilization_percentage
        }))
      };
    }) || [];

  const projectData =
    staffProjects?.map((p) => ({
      projectName: p.project.project,
      totalUtilization: p.total_utilization,

      members: p.members.map((m) => ({
        name: `${m.user.first_name} ${m.user.last_name}`,
        role: m.role.role,
        utilization_percentage: m.utilization_percentage,
        utilizationType: m.utilization_type
      }))
    })) || [];

  const Metrics = [
    {
      label: 'Active Projects',
      count: projectCount || 0,
      icon: <ShareAltOutlined />,
      iconBg: '#fff7e6',
      iconColor: '#fa8c16'
    },
    {
      label: 'Available Members',
      count: staffingStats?.available || 0,
      icon: <CheckOutlined />,
      iconBg: '#e6fffb',
      iconColor: '#52c41a'
    },
    {
      label: 'Overloaded Members',
      count: staffingStats?.overloaded || 0,
      icon: <WarningOutlined />,
      iconBg: '#fff1f0',
      iconColor: '#ff4d4f'
    }
  ];
  const user = getLoggedInUser();
  // user?.user_details?.role_id === MANAGER
  console.log(user?.user_details?.role_id, 'role id ');

  return (
    <div
      className="p-6 space-y-6 bg-gray-50 min-h-screen"
      style={{ paddingTop: '0px' }}
    >
      <div className="flex  justify-between">
        <Title level={5} className={'!text-xl !m-0 lg:!text-3xl !font-bold'}>
          Staffing Management
        </Title>
        <CustomButton type="outlined" onClick={() => navigate('/dashboard')}>
          <ArrowLeftOutlined /> Back to Dashboard
        </CustomButton>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {Metrics.map((metric, index) => (
          <CountCard
            key={index}
            label={metric.label}
            count={metric.count}
            icon={metric.icon}
            iconBg={metric.iconBg}
            iconColor={metric.iconColor}
            countColor={metric.iconColor}
          />
        ))}
      </div>

      <div
        className="bg-white p-6 rounded-xl shadow-sm border "
        style={{ border: '1px solid #E5E7EB' }}
      >
        <Row className="flex justify-between">
          <h2 className="font-semibold text-lg mb-4 text-gray-800">
            {viewMode === 'member' ? 'Team Utilization' : 'Project Utilization'}
          </h2>
          <div className="flex flex-col sm:flex-row gap-2 pb-[10px] sm:gap-0 sm:pb-0">
            <div>
              {viewMode === 'member' ? (
                <Select
                  showSearch
                  placeholder="Select member"
                  allowClear
                  value={selectedEmployee}
                  onChange={(value) => setSelectedEmployee(value)}
                  className="w-full sm:w-40"
                >
                  {data.map((employee) => (
                    <Select.Option key={employee.name} value={employee.name}>
                      {employee.name}
                    </Select.Option>
                  ))}
                </Select>
              ) : (
                <Select
                  showSearch
                  placeholder="Select project"
                  allowClear
                  value={selectedProject}
                  onChange={(v) => setSelectedProject(v)}
                  // style={{ minWidth: 160 }}
                  className="w-full sm:w-40"
                >
                  {projectData.map((p) => (
                    <Select.Option key={p.projectName} value={p.projectName}>
                      {p.projectName}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </div>
            <div>
              <CustomButton
                type="primary"
                className="lg:ml-[10px]"
                onClick={() => {
                  setViewMode(viewMode === 'member' ? 'project' : 'member');
                  setSelectedEmployee(null);
                  setSelectedProject(null);
                }}
              >
                {viewMode === 'member' ? 'Project View' : 'Member View'}
              </CustomButton>

              {user?.user_details?.role_id === EXECUTIVE ? (
                <CustomButton
                  type="primary"
                  onClick={handleClick}
                  className="mt-[-5px] ml-[10px]"
                  style={{ padding: '8px 16px' }}
                >
                  <UserSwitchOutlined />
                  Manage
                </CustomButton>
              ) : null}
            </div>
          </div>
        </Row>
        <div
          className={`grid grid-cols-12 font-semibold text-gray-800 border-b mb-3 text-sm ${styles.ut}`}
        >
          <div className="col-span-3">
            {viewMode === 'member' ? 'Member' : 'Projects'}
          </div>
          <div className="col-span-4">
            {viewMode === 'member' ? 'Active Projects' : 'Members'}
          </div>
          <div className="col-span-5 pl-[40px]">
            {' '}
            {viewMode === 'member' ? 'Utilization' : ''}
          </div>
        </div>

        {data.length === 0 ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: 'rgb(187, 187, 187)',
              fontWeight: 600
            }}
          >
            No staffing plan to show
          </div>
        ) : // data
        //   .sort((a, b) => b.utilization - a.utilization)
        //   .map((employee, index) => (
        viewMode === 'member' ? (
          (selectedEmployee
            ? data.filter((emp) => emp.name === selectedEmployee)
            : data
          )
            .sort((a, b) => b.utilization - a.utilization)
            .map((employee, index) => (
              // <div
              //   key={index}
              //   className="grid grid-cols-12 items-start border-b last:border-b-0 text-sm bg-[#f8f9fa] mb-[10px] rounded-[10px] px-[10px] py-[8px]"
              // >
              //   {/* Employee */}
              //   <div className="col-span-3 flex items-start gap-3 mt-[5px]">
              //     <Avatar
              //       size="large"
              //       style={{
              //         backgroundColor: colorHash.hex(employee.name),
              //         color: '#fff'
              //       }}
              //     >
              //       {getInitials(employee.name)}
              //     </Avatar>
              //     <div>
              //       <p className="font-semibold text-gray-700 mt-[10px]">
              //         {employee.name}
              //       </p>
              //     </div>
              //   </div>

              //   {/* Projects */}
              //   <div className="col-span-4 space-y-2">
              //     {employee.projects.length > 0 ? (
              //       employee.projects.map((project, i) => (
              //         <div
              //           key={i}
              //           className="pt-2 pr-4 pb-2 pl-2 rounded-[6px] border mt-[5px]"
              //           style={{
              //             backgroundColor:
              //               project.utilization_type === 'upcoming'
              //                 ? '#e6f0ff'
              //                 : 'white',
              //             borderLeft: `4px solid ${colorHasher.hex(
              //               project.name
              //             )}`
              //             // borderColor: 'transparent'
              //           }}
              //         >
              //           <div className="flex justify-between items-center">
              //             <div>
              //               <div className="text-sm text-gray-700 mb-[1px] font-semibold">
              //                 {project.name}
              //               </div>
              //               <div className="text-slate-500 mb-[1px] text-xs">
              //                 {project.company}
              //               </div>
              //             </div>
              //             <div>
              //               <span
              //                 style={{
              //                   backgroundColor: '#e6f0ff',
              //                   color: '#4169e1',
              //                   border: '1px solid #4169e1',
              //                   borderRadius: '12px',
              //                   padding: '2px 8px',
              //                   fontSize: 10,
              //                   fontWeight: 600
              //                 }}
              //               >
              //                 {project.utilization_percentage}%
              //               </span>
              //             </div>
              //           </div>
              //         </div>
              //       ))
              //     ) : (
              //       <div
              //         style={{
              //           display: 'flex',
              //           justifyContent: 'center',
              //           alignItems: 'center',
              //           color: 'rgb(187, 187, 187)',
              //           fontWeight: 600
              //         }}
              //       >
              //         <p>No active projects</p>
              //       </div>
              //     )}
              //   </div>

              //   {/* Utilization */}
              //   <div className="col-span-5 flex flex-col pl-[45px] gap-2">
              //     {/* <p className="text-gray-700 font-semibold mb-0 mt-2">
              //       {employee.utilization}%
              //     </p>
              //     <Progress
              //       percent={employee.utilization}
              //       showInfo={false}
              //       strokeColor={getProgressColor(employee.utilization)}
              //       className="w-[90%]"
              //       trailColor="#fff"
              //     /> */}
              //     <div className="text-gray-700 font-semibold mb-0 mt-2">
              //       {/* {employee.activeCount} Active • {employee.upcomingCount}{' '}
              //       Upcoming */}
              //       {employee.utilization}%
              //     </div>
              //     {/* <div className="w-[90%] h-2 rounded-full bg-gray-200 overflow-hidden flex">
              //       <div
              //         style={{
              //           width: `${employee.activeWidth}%`,
              //           backgroundColor: colorScheme[employee.color][0] // Active color
              //         }}
              //       ></div>
              //       <div
              //         style={{
              //           width: `${employee.upcomingWidth}%`,
              //           backgroundColor: colorScheme[employee.color][1] // Upcoming color
              //         }}
              //       ></div>
              //     </div> */}
              //     <div className="w-[90%] h-2 rounded-full bg-gray-200 overflow-hidden flex">
              //       <div
              //         style={{
              //           width: `${employee.activeWidth}%`,
              //           backgroundColor: colorScheme[employee.colorKey][0] // Active color (darker)
              //         }}
              //       ></div>
              //       <div
              //         style={{
              //           width: `${employee.upcomingWidth}%`,
              //           backgroundColor: colorScheme[employee.colorKey][1] // Upcoming color (lighter)
              //         }}
              //       ></div>
              //     </div>
              //     <div className="text-xs text-gray-500 mt-1">
              //       Active: {employee.activeUtil}% &nbsp; | &nbsp; Upcoming:{' '}
              //       {employee.upcomingUtil}%
              //     </div>
              //   </div>
              // </div>
              <div
                key={index}
                className="grid grid-cols-1 md:grid-cols-12 items-start border-b last:border-b-0 text-sm bg-[#f8f9fa] mb-[10px] rounded-[10px] px-[10px] py-[8px] gap-3"
              >
                {/* Employee */}
                <div className="flex items-start gap-3 mt-[5px] md:col-span-3">
                  <Avatar
                    size="large"
                    style={{
                      backgroundColor: colorHash.hex(employee.name),
                      color: '#fff'
                    }}
                  >
                    {getInitials(employee.name)}
                  </Avatar>
                  <div>
                    <p className="font-semibold text-gray-700 mt-[10px]">
                      {employee.name}
                    </p>
                  </div>
                </div>

                {/* Projects */}
                <div className="space-y-2 md:col-span-4">
                  {employee.projects.length > 0 ? (
                    employee.projects.map((project, i) => (
                      <div
                        key={i}
                        className="pt-2 pr-4 pb-2 pl-2 rounded-[6px] border mt-[5px]"
                        style={{
                          backgroundColor:
                            project.utilization_type === 'upcoming'
                              ? '#e6f0ff'
                              : 'white',
                          borderLeft: `4px solid ${colorHasher.hex(
                            project.name
                          )}`
                        }}
                      >
                        <div className="flex justify-between items-center">
                          <div>
                            <div className="text-sm text-gray-700 mb-[1px] font-semibold">
                              {project.name}
                            </div>
                            <div className="text-slate-500 mb-[1px] text-xs">
                              {project.company}
                            </div>
                          </div>
                          <div>
                            <span
                              style={{
                                backgroundColor: '#e6f0ff',
                                color: '#4169e1',
                                border: '1px solid #4169e1',
                                borderRadius: '12px',
                                padding: '2px 8px',
                                fontSize: 10,
                                fontWeight: 600
                              }}
                            >
                              {project.utilization_percentage}%
                            </span>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="flex justify-center items-center text-gray-400 font-semibold">
                      <p>No active projects</p>
                    </div>
                  )}
                </div>

                {/* Utilization */}
                <div className="flex flex-col gap-2 md:col-span-5 md:pl-[45px]">
                  <div className="text-gray-700 font-semibold mb-0 mt-2">
                    {employee.utilization}%
                  </div>
                  <div className="w-full md:w-[90%] h-2 rounded-full bg-gray-200 overflow-hidden flex">
                    <div
                      style={{
                        width: `${employee.activeWidth}%`,
                        backgroundColor: colorScheme[employee.colorKey][0] // Active color
                      }}
                    ></div>
                    <div
                      style={{
                        width: `${employee.upcomingWidth}%`,
                        backgroundColor: colorScheme[employee.colorKey][1] // Upcoming color
                      }}
                    ></div>
                  </div>
                  <div className="text-xs text-gray-500 mt-1">
                    Active: {employee.activeUtil}% &nbsp; | &nbsp; Upcoming:{' '}
                    {employee.upcomingUtil}%
                  </div>
                </div>
              </div>
            ))
        ) : (
          (selectedProject
            ? projectData.filter((p) => p.projectName === selectedProject)
            : projectData
          )

            .sort((a, b) => b.totalUtilization - a.totalUtilization)
            .map((project, index) => (
              // <div
              //   key={index}
              //   className="grid grid-cols-12 items-start border-b last:border-b-0 text-sm bg-[#f8f9fa] mb-[10px] rounded-[10px] px-[10px] py-[8px]"
              // >

              //   <div className="col-span-3 flex items-start gap-3 mt-[5px]">
              //     <Avatar
              //       size="large"
              //       style={{
              //         backgroundColor: colorHash.hex(project.projectName),
              //         color: '#fff'
              //       }}
              //     >
              //       {getInitials(project.projectName)}
              //     </Avatar>
              //     <p className="font-semibold text-gray-700 mt-[10px]">
              //       {project.projectName}
              //     </p>
              //   </div>

              //   <div className="col-span-9">
              //     <div className="grid grid-cols-2 gap-4">
              //       {project.members.map((m, i) => (
              //         <div
              //           key={i}
              //           className="col-span-1 pt-2 pr-4 pb-2 pl-2 rounded-[6px] border"
              //           style={{
              //             backgroundColor:
              //               m.utilizationType === 'upcoming'
              //                 ? '#e6f0ff'
              //                 : 'white',
              //             borderLeft: `4px solid ${colorHasher.hex(m.name)}`
              //           }}
              //         >
              //           <div className="flex justify-between items-center">
              //             <div>
              //               <div className="text-sm text-gray-700 font-semibold">
              //                 {m.name}
              //               </div>
              //               <div className="text-slate-500 text-xs">
              //                 {m.role}
              //               </div>
              //             </div>
              //             <div>
              //               <span
              //                 style={{
              //                   backgroundColor: '#e6f0ff',
              //                   color: '#4169e1',
              //                   border: '1px solid #4169e1',
              //                   borderRadius: '12px',
              //                   padding: '2px 8px',
              //                   fontSize: 10,
              //                   fontWeight: 600
              //                 }}
              //               >
              //                 {m.utilization_percentage}%
              //               </span>
              //             </div>
              //           </div>
              //         </div>
              //       ))}
              //     </div>
              //   </div>

              //   <div className="col-span-5 flex flex-col pl-[45px] gap-2">
              //     <div className="text-gray-700 font-semibold mt-2">
              //       Total utilization : {project.totalUtilization}%
              //     </div>
              //     <div className="w-[90%] h-2 rounded-full bg-gray-200 overflow-hidden flex">
              //       <div
              //         style={{
              //           width: `${project.totalUtilization}%`,
              //           backgroundColor:
              //             project.totalUtilization > 100
              //               ? '#EF4444' // red
              //               : project.totalUtilization > 80
              //               ? '#3B82F6' // blue
              //               : '#27C36A' // green
              //         }}
              //       ></div>
              //     </div>
              //   </div>
              // </div>
              <div
                key={index}
                className="grid grid-cols-1 md:grid-cols-12 items-start border-b last:border-b-0 text-sm bg-[#f8f9fa] mb-[10px] rounded-[10px] px-[10px] py-[8px] gap-3"
              >
                {/* Project */}
                <div className="flex items-start gap-3 mt-[5px] md:col-span-3">
                  <Avatar
                    size="large"
                    style={{
                      backgroundColor: colorHash.hex(project.projectName),
                      color: '#fff'
                    }}
                  >
                    {getInitials(project.projectName)}
                  </Avatar>
                  <p className="font-semibold text-gray-700 mt-[10px]">
                    {project.projectName}
                  </p>
                </div>

                {/* Members */}
                <div className="md:col-span-9">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {project.members.map((m, i) => (
                      <div
                        key={i}
                        className="pt-2 pr-4 pb-2 pl-2 rounded-[6px] border"
                        style={{
                          backgroundColor:
                            m.utilizationType === 'upcoming'
                              ? '#e6f0ff'
                              : 'white',
                          borderLeft: `4px solid ${colorHasher.hex(m.name)}`
                        }}
                      >
                        <div className="flex justify-between items-center">
                          <div>
                            <div className="text-sm text-gray-700 font-semibold">
                              {m.name}
                            </div>
                            <div className="text-slate-500 text-xs">
                              {m.role}
                            </div>
                          </div>
                          <div>
                            <span
                              style={{
                                backgroundColor: '#e6f0ff',
                                color: '#4169e1',
                                border: '1px solid #4169e1',
                                borderRadius: '12px',
                                padding: '2px 8px',
                                fontSize: 10,
                                fontWeight: 600
                              }}
                            >
                              {m.utilization_percentage}%
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))
        )}
      </div>
    </div>
  );
};

export default StaffPlanning;
